/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FanOriginDto } from '../models/FanOriginDto';
import type { FanOriginRequestDto } from '../models/FanOriginRequestDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FanOriginChattingUiApiService {
    /**
     * Update fan origin
     * @returns FanOriginDto Fan origin successfully updated
     * @throws ApiError
     */
    public static updateFanOriginForCreatorChattingUi({
        creatorId,
        id,
        requestBody,
    }: {
        creatorId: number,
        id: number,
        /**
         * Name of an updated fan origin
         */
        requestBody: FanOriginRequestDto,
    }): CancelablePromise<FanOriginDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/of-chat/{creatorId}/origin/{id}',
            path: {
                'creatorId': creatorId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Invalid creator`,
                404: `Invalid fan origin for update`,
                409: `Fan origin with such name already exists`,
            },
        });
    }
    /**
     * Delete fan origin
     * @returns void
     * @throws ApiError
     */
    public static deleteFanOriginForCreatorChattingUi({
        creatorId,
        id,
    }: {
        creatorId: number,
        id: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/dashboard/api/v1/of-chat/{creatorId}/origin/{id}',
            path: {
                'creatorId': creatorId,
                'id': id,
            },
            errors: {
                403: `Invalid creator`,
            },
        });
    }
    /**
     * Gat all fan origins for creator
     * @returns FanOriginDto All fan origins
     * @throws ApiError
     */
    public static getFanOriginsForCreatorChattingUi({
        creatorId,
    }: {
        creatorId: number,
    }): CancelablePromise<Array<FanOriginDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/of-chat/{creatorId}/origin',
            path: {
                'creatorId': creatorId,
            },
            errors: {
                403: `Invalid creator`,
            },
        });
    }
    /**
     * Create fan origin
     * @returns FanOriginDto Fan origin successfully created
     * @throws ApiError
     */
    public static createFanOriginForCreatorChattingUi({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        /**
         * Name of a new fan origin
         */
        requestBody: FanOriginRequestDto,
    }): CancelablePromise<FanOriginDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/of-chat/{creatorId}/origin',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Invalid creator`,
                409: `Fan origin already exists`,
            },
        });
    }
}
